<!--
 * @description: 科普践行 科普Tab 内容
 * @Author: Jay
 * @Date: 2021-09-24 16:35:01
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:37:27
-->
<template>
  <div v-class="'animate__animated animate__fadeInUp'">
    <div class="box-shadow">
      <!-- tab切换 -->
      <div class="flex">
        <div
          style="width: 100%"
          v-for="(item, index) in coupeList"
          :key="index"
        >
          <div class="tab-code text-align">
            <p
              class="font_size_lg"
              :class="tabIndex == index ? 'active' : ''"
              @click="selectTap(index)"
            >
              {{ item.name }}
            </p>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div v-for="(item, index) in coupeList" :key="index">
        <div class="flex" v-if="tabIndex == index">
          <template v-if="item.article != null">
            <div class="left-img">
              <el-image
                :src="$api + item.article.image"
                fit="fill"
                :lazy="true"
              >
                <div
                  slot="placeholder"
                  class="text-black flex align-center justify-center"
                  style="height: 100%"
                >
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <!-- <div class="img-name font_size_df">
                {{ item.name }}
              </div> -->
            </div>
            <div class="padding code-name">
              <p v-html="item.article.content"></p>
            </div>
          </template>
          <div class="flex justify-center flex-sub" v-else>
            <el-result
              icon="info"
              title="内容为空"
              subTitle="请联系管理员及时更新"
            >
            </el-result>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoupeTopCode",
  props: ["coupeList"],
  data() {
    return {
      tabIndex: 0,
      tabList: [
        {
          name: "一切从用户出发",
          img: "https://scpic.chinaz.net/Files/pic/pic9/202109/apic35320_s.jpg",
        },
        {
          name: "做强比做大更重要",
          img: "https://scpic1.chinaz.net/Files/pic/pic9/202109/apic35323_s.jpg",
        },
        {
          name: "一切从用户出发",
          img: "https://scpic.chinaz.net/Files/pic/pic9/202109/apic35320_s.jpg",
        },
        {
          name: "做强比做大更重要",
          img: "https://scpic1.chinaz.net/Files/pic/pic9/202109/apic35323_s.jpg",
        },
        {
          name: "一切从用户出发",
          img: "https://scpic.chinaz.net/Files/pic/pic9/202109/apic35320_s.jpg",
        },
      ],
    };
  },
  methods: {
    //tab 切换
    selectTap(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
// tab 切换
.tab-code {
  flex: 1;
  height: 119px;
  line-height: 119px;
  border-right: 1px solid #f0f0f0;
}
.active {
  border-right: #0077c0;
  background-color: #0077c0;
  color: #fff;
}
// 内容
.left-img {
  position: relative;
  width: 239px;
  height: 346px;
  color: #fff;
  overflow: hidden;
  .el-image {
    width: 100%;
    height: 100%;
  }
}
.img-name {
  position: absolute;
  left: 20%;
  top: 50%;
}

.code-name {
  width: 690px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 200px;
  p {
    margin-bottom: 15px;
  }
}
</style>